import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import { ListView } from '@progress/kendo-react-listview';
import './SuspenseQueue.scss';
import AddToQueueModal from '../modals/SuspenseQueue/AddToQueueModal/AddToQueueModal';
import {
  getWorkQueueDemo,
  getWorkQueue,
  createKofaxJob,
  deleteKofaxJob,
  getWorkQueueFilters,
  claimJob,
  completeActivity,
  submitDirectlyToSubmissionAPI,
  updateDocTypeName,
} from '../../services/scanOnDemandService';
import { getDocDetail, objectSpecificList, getCustomers } from '../../services/metadataSubmissionService';
import SuspenseQueueList from '../SuspenseQueueList/SuspenseQueueList';
import Moment from 'moment';
import Collapsible from 'react-collapsible';
import LoadingSplash from '../LoadingSplash/LoadingSplash';
import { faChevronUp, faChevronDown, faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorGrowl from './ErrorGrowl';
import SuccessProcessGrowl from './SuccessProcessGrowl';
import SuccessfullyProcessedList from '../SuccessQueueList/SuccessfullyProcessedList';
import SuspenseQueueFilters from '../SuspenseQueueFilters/SuspenseQueueFilters';
import InformationModal from '../modals/SuspenseQueue/InformationModal/InformationModal';
import OCRModal from '../modals/SuspenseQueue/OCRModal/OCRModal';
import UserContext from '../UserContext/UserContext';
import DetailsView from '../modals/DetailsView/DetailsView';
import IndexSheetModal from '../modals/SuspenseQueue/IndexSheetModalV2/IndexSheetModalV2';
import zIndex from '@material-ui/core/styles/zIndex';
import AddButton from '../../fsa-style/img/svgs/AddButton.svg';
import SuspenseQueuePopup from './SuspenseQueuePopup/SuspenseQueuePopup';
import { uploadToS3, getFileUploadStatus } from '../../services/scanOnDemandService';
import _ from 'lodash';
import { GlobalLoader } from '../../newcomponents/GlobalLoader/GlobalLoader';
import PreviewDocument from '../modals/PreviewDocuement/PreviewDocument';
import { Pager } from '@progress/kendo-react-data-tools';
import DocumentErrorModal from '../../newcomponents/DocumentErrorModal/DocumentErrorModal';
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import { getDoctype } from '../../services/suspenseQueueService';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CircularProgress } from '@material-ui/core';
import previewPageIcon from '../../fsa-style/img/svgs/PreviewIcon.svg';
import ClosePreviewIcon from '../../fsa-style/img/svgs/ClosePreviewIcon.svg';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';

let FileData;
const customStyles = {
  control: (base) => ({
    ...base,
    height: 32,
    minHeight: 32,
    width: 110,
    zIndex: 99999,
  }),
  menu: (base) => ({
    ...base,
    // width: '222px',
    zIndex: 9999999999,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999999999 }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: 32,
    position: 'initial',
    padding: '0px 8px',
    width: 110,
    zIndex: 99999999,
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: 32,
  }),
  input: (provided, state) => ({
    ...provided,
    height: 32,
    padding: 0,
    margin: 0,
  }),
  container: (provided, state) => ({
    ...provided,
    width: 110,
  }),
};

if (JSON.parse(sessionStorage.getItem('filesList')) === null || JSON.parse(sessionStorage.getItem('filesList')) === undefined) {
  FileData = [];
} else {
  FileData = JSON.parse(sessionStorage.getItem('filesList'));
}

let FileData1;
if (JSON.parse(sessionStorage.getItem('filesList1')) === null || JSON.parse(sessionStorage.getItem('filesList1')) === undefined) {
  FileData = [];
} else {
  FileData = JSON.parse(sessionStorage.getItem('filesList1'));
}

export default function SuspenseQueue() {
  //Info Modal variables
  const [infoPopUp, setInfoPopUp] = useState(false);
  const [infoJobStatus, setInfoJobStatus] = useState('');
  const [infoJobCreationDate, setInfoJobCreationDate] = useState();
  const [infoJobFileName, setInfoJobFileName] = useState('');
  const [infoJobStatusNote, setInfoJobStatusNote] = useState('');
  const [infoJobId, setInfoJobId] = useState('');
  const [infoUser, setInfoUser] = useState('');
  //END Info Modal variables

  //OCR Modal variables
  const [OCRPopup, setOCRPopup] = useState(false);
  const [OCRActivityURL, setOCRJobActivityURL] = useState('');
  //END OCR Modal variables

  //Preview Modal variables
  const [previewPopup, setPreviewPopup] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [objectMetadata, setObjectMetadata] = useState();
  const [doc, setDoc] = useState();
  const [docName, setDocName] = useState('');
  const [docType, setDocType] = useState(null);
  const [detailsPageCount, setDetailsPageCount] = useState(0);
  const [scimsCustomers, setScimsCustomers] = useState(null);
  const [metadataDisplayList, setMetadataDisplayList] = useState(null);
  const [message, setMessage] = useState('');

  //END Preview Modal variables

  //Index Sheet variables
  const [indexSheetPopup, setIndexSheetPopup] = useState(false);
  //END Index Sheet variables

  //Unprocessed Variables
  const unprocessedResultSet = 1;
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [unprocessedFilesTotal, setUnprocessedFilesTotal] = useState(0);
  const [unprocessedMinimized, setUnprocessedMinimized] = useState(false);
  const [submitToKofaxInProgress, setSubmitToKofaxInProgress] = useState(false);
  const [deleteFilesInProgress, setDeleteFilesInProgress] = useState(false);
  const [checkedAll, setCheckedAll] = useState(false);
  const [id, setId] = useState(0);
  const [popupOpen, setPopupOpen] = useState(false);
  //END Unprocessed Variables

  //Suspense Queue Variables
  const suspenseQueueResultSet = 2;
  const [filesInSuspenseQueue, setFilesInSuspenseQueue] = useState([]);
  const [suspenseQueueTotal, setSuspenseQueueTotal] = useState(0);
  const [page, setPage] = useState({ skip: 0, take: 25 });
  const { skip, take } = page;
  const [suspenseQueueMinimized, setSuspenseQueueMinimized] = useState(true);
  //END Suspense Queue Variables

  //Stored in DRMS Variables
  const storedInDRMSResultSet = 3;
  const [successfulFilesStoredInDrms, setSuccessfulFilesStoredInDrms] = useState([]);
  const [storedInDRMSTotal, setStoredInDRMSTotal] = useState(0);
  const [drmsPage, setDrmsPage] = useState({ drmsSkip: 0, drmsTake: 25 });
  const { drmsSkip, drmsTake } = drmsPage;
  const [successfullyProcessedMinimized, setSuccessfullyProcessedMinimized] = useState(true);
  //END Stored in DRMS Variables

  //Filter Variables
  const [filtersMinimized, setFiltersMinimized] = useState(false);
  const [jobStatusValues, setJobStatusValues] = useState([]);
  const [userFilterValues, setUserFilterValues] = useState([]);
  const [docTypeValues, setDocTypeValues] = useState([]);
  const [jobStatusSelection, setJobStatusSelection] = useState([0]);
  const [userSelection, setUserSelection] = useState(['Any']);
  const [docTypeSelection, setDocTypeSelection] = useState(['Any']);
  const [startDateSelection, setStartDateSelection] = useState();
  const [endDateSelection, setEndDateSelection] = useState();
  //END Filter Variables

  //General Variables
  const { userInfo, setUserInfo, userPermissions } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  // const [errorConnecting, setErrorConnecting] = useState(false);
  const [isSuccessGrowlHidden, setIsSuccessGrowlHidden] = useState(true);
  const [isSuccessGrowlHidden2, setIsSuccessGrowlHidden2] = useState(true);
  const [isDocumentModalHidden, setIsDocumentModalHidden] = useState(true);

  const [isErrorGrowlHidden, setIsErrorGrowlHidden] = useState(true);
  const [isErrorGrowlHidden2, setIsErrorGrowlHidden2] = useState(true);
  const [isErrorGrowlHidden3, setIsErrorGrowlHidden3] = useState(true);

  //END General Variables
  const [ismodalOpen, setIsModalOpen] = useState(false);
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [isModalCollapsed, setIsModalCollapsed] = useState(false);
  const [progressVal, setProgressVal] = useState(80);
  const [progressVal2, setProgressVal2] = useState(0);
  const [filesData, setFilesData] = useState(FileData);
  const [filesData1, setFilesData1] = useState(FileData1);
  const intervalRef = useRef();
  const [intervalId, setIntervalId] = useState(null);
  const [fileloading, setFileloading] = useState(false);
  const [invalidFileMsg, setInvalidFileMsg] = useState('');
  const [fileProcessing, setFileProcessing] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [intervalIds, setIntervalIds] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isUploadedLoader, setUploadedLoader] = useState(false);
  const [versionErrorMsg, setVersionErrorMsg] = useState('');
  const [isModalOpen, setIsModelOpen] = useState(false);

  const [documentTitle, setDocumentTitle] = useState();
  const [sections, setSections] = useState();
  const [startTimeoutFunc, setStartTimeoutFunc] = useState(true);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [searchErrorMessage, setSearchErrorMessage] = useState('');
  const [triggerPointFirefox, setTriggerPointFirefox] = useState(null);
  const [suspenseQueueListLoader, setSuspenseQueueListLoader] = useState(false);
  const [successfullyProcessedListLoader, setSuccessfullyProcessedListLoader] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [fileSizeErr, setFileSizeErr] = useState('');
  const [previewImageData, setPreviewImageData] = useState(null);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  useEffect(() => {
    //Modify to use eauth's jwt when we hook up
    let storage = JSON.parse(sessionStorage.getItem('filesList'));

    let FileData = storage;

    getData();
  }, [FileData]);

  const getData = () => {
    setFilesData(JSON.parse(sessionStorage.getItem('filesList')));
  };

  useEffect(() => {
    //Modify to use eauth's jwt when we hook up
    const getdoc = async () => {
      try {
        const response = await getDoctype();
        if (Array.isArray(response.data)) {
          setDocumentTypes(response.data);
        } else {
          console.error('Invalid data format from API:', response.data);
        }
      } catch (error) {
        console.error('Error in getDoctype:', error.message);
      }
    };

    getdoc();
    getSuspenseQueueFilters().then(() => { });
    retrieveWorkQueue();
  }, []);

  const closeDocErrorModal = (e) => {
    // setIsModalOpen(false);
    setIsModelOpen(false);
  };
  useEffect(() => {
    if (isFileUploaded === true && fileProcessing === false) {
      refreshUnprocessed();
    }
  }, [fileProcessing, isFileUploaded]);

  useEffect(() => {
    if (filesData) {
      let uploadedFiles = filesData.filter((item) => item.progressVal2 !== 100);
      if (uploadedFiles.length && startTimeoutFunc) {
        let index = 0;
        const intervalId = setInterval(() => {
          if (index < uploadedFiles.length) {
            getFilesData();
            index++;
          } else {
            clearInterval(intervalId);
          }
        }, 20000);
        setIntervalIds([...intervalIds, intervalId]);
      } else {
        intervalIds.forEach((interval) => clearInterval(interval));
        setIntervalIds([]);
        retrieveWorkQueue();
      }
      return () => {
        intervalIds.forEach((interval) => clearInterval(interval));
      };
    }
  }, [filesData, unprocessedFilesTotal]);

  //File upload
  const handleAddButton = () => {
    setIsModalOpen(true);
  };
  const toggleModalCollapse = () => {
    setIsModalCollapsed(!isModalCollapsed);
  };

  const TriggerPointFirefoxFunc = useCallback(
    (event) => {
      setTriggerPointFirefox(event.clientY);
      setTimeout(() => {
        setTriggerPointFirefox(event.clientY);
      }, 50);
    },
    [triggerPointFirefox]
  );

  const closeUpload = () => {
    setIsModalOpen(false);
    setIsModalCollapsed(false);
  };
  const handleUpload = (e) => {
    e.preventDefault();
    setIsUploadSuccess(false);
    setTimeout(() => {
      setIsUploadSuccess(true);
    }, 2000);
  };

  const validateFile = (file) => {
    let ext = file.name.split('.').pop();
    const validTypes = ['pdf', 'docx', 'doc'];
    if (validTypes.indexOf(ext) === -1) return false;
    return true;
  };

  const onFilesAdded = (files) => {
    setIsModalOpen(true);
    setFileloading(true);
    setFileProcessing(true);
    let list = [];

    if (filesData !== null) {
      list = filesData;
    }
    if (files !== 0) {
      for (let i = 0; i < files.length; i++) {
        if (validateFile(files[i])) {
          let file = files[i];
          setFileloading(true);
          setFileProcessing(true);
          if (files[i].name.includes('&')) {
            let modifiedFileName = files[i].name.replace('&', 'and');
            file = new File([files[i]], modifiedFileName, { type: files[i].type });
          }
          uploadToS3(file)
            .then((response) => {
              list.unshift({
                fileName: file?.name,
                status: 'Uploaded',
                status1: 'Processing',
                fileSize: file.size / 1024,
                progressVal: 100,
                progressVal2: 25,
                fileId: response?.data?.[0],
                errorMessage: null,
              });
              sessionStorage.setItem('filesList', JSON.stringify(list));
              setFileloading(false);
              setFileProcessing(true);
              setStartTimeoutFunc(true);
              setIsFileUploaded(true);
            })
            .then(() => {
              let newList = JSON.parse(JSON.stringify(list));
              setFilesData(newList);
            });
        } else {
          files[i]['invalid'] = true;
          onAddInvalidFiles();
          setIsFileUploaded(false);
        }
      }
    }
  };

  const onCheckVersion = () => {
    setIsModalOpen(true);
    setIsModelOpen(true);
  };

  const onAddInvalidFiles = () => {
    setIsErrorGrowlHidden(false);
    setInvalidFileMsg('Invalid file type.');
    setTimeout(() => {
      setIsErrorGrowlHidden(true);
    }, 3000);
    setFileloading(false);
  };

  const getFilesData = () => {
    let fileList = JSON.parse(sessionStorage.getItem('filesList'));
    let fileIdList = fileList.map((item) => {
      return item?.fileId?.FileId;
    });
    // API
    getFileUploadStatus(fileIdList).then((response) => {
      let data = response.data;

      let result = fileList.map((item, i) => {
        data?.map((obj) => {
          if (obj.fileId === item.fileId.FileId && obj.errorMessage !== null) {
            item.errorMessage = obj.errorMessage;
            setErrorMsg(item.errorMessage);
          } else if (obj.fileId === item.fileId.FileId && obj.status === true && obj.errorMessage === null) {
            //This condition is added because large files were not reflecting after processing(BAS-2197 02-08-2024)
            if (obj.fileId === item.fileId.FileId && item?.status1 === 'Processed') {
              return;
            }
            item.progressVal2 = 100;
            item.status1 = 'Processed';
            setFileProcessing(false);
          } else if (obj.fileId === item.fileId.FileId && obj.status === false) {
            setFileProcessing(true);
            setIsFileUploaded(true);
          }
        });
        return { ...item };
      });
      sessionStorage.setItem('filesList', JSON.stringify(result));
      let newList = JSON.parse(JSON.stringify(result));

      let mainlist = result;
      let list = mainlist.filter((item) => item.progressVal2 !== 100);
      if (list.length == 0) {
        setStartTimeoutFunc(false);
        setFilesData(newList);
        return () => clearInterval(intervalRef.current);
      } else {
        setFilesData(newList);
        setStartTimeoutFunc(true);
      }

      return () => clearInterval(intervalRef.current);
    });
  };
  //End -> File upload

  const handleApplyFilters = (jobSelection, documentSelection, userSelection, startDate, endDate) => {
    setJobStatusSelection(jobSelection);
    setUserSelection(userSelection);
    setDocTypeSelection(documentSelection);
    setStartDateSelection(startDate === 'clear' ? undefined : startDate);
    setEndDateSelection(endDate === 'clear' ? undefined : endDate);
    filterSuspenseQueue({
      jobs: jobSelection,
      users: userSelection,
      docTypes: documentSelection,
      startDate: startDate,
      endDate: endDate,
    });
  };

  const filterSuspenseQueue = async ({ jobs, users, docTypes, startDate, endDate }) => {
    await getPage({
      rowLimit: take,
      page: 1,
      resultSet: suspenseQueueResultSet,
      jobs: jobs,
      users: users,
      docTypes: docTypes,
      startDate: startDate,
      endDate: endDate,
    }).then(
      setPage({
        skip: 0,
        take: take,
      })
    );

    await getPage({
      rowLimit: drmsTake,
      page: 1,
      resultSet: storedInDRMSResultSet,
      jobs: jobs,
      users: users,
      docTypes: docTypes,
      startDate: startDate,
      endDate: endDate,
    }).then(
      setDrmsPage({
        drmsSkip: 0,
        drmsTake: drmsTake,
      })
    );

    await getPage({
      resultSet: unprocessedResultSet,
      jobs: jobs,
      users: users,
      docTypes: docTypes,
      startDate: startDate,
      endDate: endDate,
    });
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  ///Gets the next page for the Suspense Queue section of the Suspense Queue
  const handleSQPageChange = async (event) => {
    const { skip, take } = event;
    setPage({
      ...page,
      skip: skip,
      take: take,
    });
    await getPage({
      rowLimit: take,
      page: skip === 0 ? 1 : skip / take + 1,
      resultSet: suspenseQueueResultSet,
    });
  };

  ///Gets the next page for the Stored in DRMS section of the Suspense Queue
  const handleDRMSPageChange = async (event) => {
    const { skip, take } = event;
    setDrmsPage({
      ...drmsPage,
      drmsSkip: skip,
      drmsTake: take,
    });

    await getPage({
      rowLimit: take,
      page: skip === 0 ? 1 : skip / take + 1,
      resultSet: storedInDRMSResultSet,
    });
  };

  ///Calls SoD to get the latest Suspense Queue and Successfully Stored in DRMS list
  const handleRefreshQueue = async () => {
    await getPage({
      rowLimit: take,
      page: 1,
      resultSet: suspenseQueueResultSet,
    }).then(
      setPage({
        skip: 0,
        take: take,
      })
    );

    await getPage({
      rowLimit: drmsTake,
      page: 1,
      resultSet: storedInDRMSResultSet,
    }).then(
      setDrmsPage({
        drmsSkip: 0,
        drmsTake: drmsTake,
      })
    );
  };

  const getPage = async ({ rowLimit, page, resultSet, jobs, users, docTypes, startDate, endDate }) => {
    let loadNextPage = [];

    if (resultSet === suspenseQueueResultSet) {
      setSuspenseQueueListLoader(true);
      getWorkQueueDemo({
        resultSet: resultSet,
        limit: rowLimit,
        page: page,
        jobStatusFilter: jobs !== undefined ? jobs : jobStatusSelection,
        userFilter: users !== undefined ? users : userSelection,
        docTypeFilter: docTypes !== undefined ? docTypes : docTypeSelection,
        startDate: startDate !== undefined ? (startDate === 'clear' ? undefined : startDate) : startDateSelection,
        endDate: endDate !== undefined ? (endDate === 'clear' ? undefined : endDate) : endDateSelection,
      }).then((response) => {
        response.data !== 'No records for the provided filters.' &&
          response.data['results'].map((job) => {
            loadNextPage.push({
              FileId: job.FileId,
              isChecked: false,
              FileName: job.FileName,
              UploadDate: Moment(job.UploadDate).format('MM-DD-YYYY'),
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobId: job.JobId,
              JobSubmissionDate: job.JobSubmissionDate,
              ActivityUrl: job.ActivityUrl,
              UserName: job.UserName,
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              LastModifiedBy: job.LastModifiedBy,
              FileNameOriginal: job.FileNameOriginal,
            });
            setSuspenseQueueListLoader(false);
          });
        if (response.data !== 'No records for the provided filters.') {
          setSuspenseQueueTotal(response.data['total_hits']);
        } else {
          setSuspenseQueueTotal(0);
        }

        setFilesInSuspenseQueue(loadNextPage);
      });
    } else if (resultSet === storedInDRMSResultSet) {
      setSuccessfullyProcessedListLoader(true);
      getWorkQueueDemo({
        resultSet: resultSet,
        limit: rowLimit,
        page: page,
        // No point in having a Job Status filter for Successfully stored in DRMS call since they all have the same status
        userFilter: users !== undefined ? users : userSelection,
        docTypeFilter: docTypes !== undefined ? docTypes : docTypeSelection,
        startDate: startDate !== undefined ? (startDate === 'clear' ? undefined : startDate) : startDateSelection,
        endDate: endDate !== undefined ? (endDate === 'clear' ? undefined : endDate) : endDateSelection,
      }).then((response) => {
        response.data !== 'No records for the provided filters.' &&
          response.data['results'].map((job) => {
            loadNextPage.push({
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              FileId: job.FileId,
              isChecked: false,
              FileName: job.FileName,
              UploadDate: Moment(job.UploadDate).format('MM-DD-YYYY'),
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobSubmissionDate: job.JobSubmissionDate,
              JobCompletionDate: job.JobCompletionDate,
              EsId: job.EsId,
              Description: job.Description,
              UserName: job.UserName,
              PageCount: job.PageCount,
              FileNameOriginal: job.FileNameOriginal,
            });
          });
        setSuccessfullyProcessedListLoader(false);
        if (response.data !== 'No records for the provided filters.') {
          setStoredInDRMSTotal(response.data['total_hits']);
        } else {
          setStoredInDRMSTotal(0);
        }
        setSuccessfulFilesStoredInDrms(loadNextPage);
      });
    } else {
      getWorkQueueDemo({
        resultSet: unprocessedResultSet,
        userFilter: users !== undefined ? users : userSelection,
        startDate: startDate !== undefined ? (startDate === 'clear' ? undefined : startDate) : startDateSelection,
        endDate: endDate !== undefined ? (endDate === 'clear' ? undefined : endDate) : endDateSelection,
      }).then((response) => {
        response.data !== 'No records for the provided filters.' &&
          response.data['results'].map((job) => {
            loadNextPage.push({
              isChecked: false,
              ActivityUrl: job.ActivityUrl,
              BatchId: job.BatchId,
              Description: job.Description,
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              EsId: job.EsId,
              FileId: job.FileId,
              FileName: job.FileName,
              FileNameOriginal: job.FileNameOriginal,
              IndexData: job.IndexData,
              IndexSheet: job.IndexSheet,
              JobCompletionDate: job.JobCompletionDate,
              JobId: job.JobId,
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobSubmissionDate: job.JobSubmissionDate,
              ObjectData: job.ObjectData,
              ObjectSheetData: job.ObjectSheetData,
              OfficeId: job.OfficeId,
              PageCount: job.PageCount,
              Thumbnail: job.Thumbnail,
              ThumbnailFileName: job.ThumbnailFileName,
              UploadDate: job.UploadDate,
              UserName: job.UserName,
            });
          });
        if (response.data !== 'No records for the provided filters.') {
          setUnprocessedFilesTotal(response.data['total_hits']);
        } else {
          setUnprocessedFilesTotal(0);
        }
        setUploadedFiles(loadNextPage);
      });
    }
  };

  //Handle Modal Popups
  const handleUploadButton = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  const handleInformationPopUpClose = () => {
    setInfoPopUp(false);
  };

  const handleOCRPopUpClose = () => {
    setOCRPopup(false);
  };

  const handleOnPreviewClose = () => {
    setPreviewPopup(false);
  };

  const handleOnSuspenseQueueItemClicked = async ({ jobId, jobStatus, jobCreationDate, fileName, jobStatusNote, activityURL, uploadingUser }) => {
    if (
      (jobStatus !== 'Metadata Update Required' &&
        jobStatus !== 'Manual Classification Required' &&
        jobStatus === 'Claimed' &&
        /*claimUserEauth*/ '28200403099030045912' !== userInfo.usdaeauthid) ||
      !jobStatus.match(/^(Metadata Update Required|Manual Classification Required|Claimed)$/)
    ) {
      setInfoJobStatus(jobStatus);
      setInfoJobCreationDate(Moment(jobCreationDate).format('MM-DD-YYYY hh:mm'));
      setInfoJobFileName(fileName);
      setInfoJobStatusNote(jobStatusNote);
      setInfoUser(uploadingUser);
      setInfoJobId(jobId);
      setInfoPopUp(true);
    } else if (
      jobStatus === 'Metadata Update Required' ||
      jobStatus === 'Manual Classification Required' ||
      (jobStatus === 'Claimed' && /*claimUserEauth*/ '28200403099030045912' === userInfo.usdaeauthid)
    ) {
      setOCRJobActivityURL(activityURL);
      await claimSuspenseQueueJob(jobId).then(setOCRPopup(true));
    }
  };

  const customSuspenseQueueList = (props) => {
    return (
      <>
        {suspenseQueueListLoader && <GlobalLoader />}
        <SuspenseQueueList {...props} onSuspenseQueueItemClicked={handleOnSuspenseQueueItemClicked} />
      </>
    );
  };

  const getFileType = (filePath) => {
    const returnedDocName = filePath;
    setDocName(returnedDocName);
    const docNameSplit = returnedDocName.split('.');
    const returnedDocType = returnedDocName.split('.')[docNameSplit.length - 1];
    if (returnedDocType === 'pdf') {
      setDocType(returnedDocType);
    } else if (returnedDocType === 'bmp' || returnedDocType === 'jpg' || returnedDocType === 'jpeg' || returnedDocType === 'img') {
      setDocType('image');
    } else {
      setDocType('');
    }
  };

  const addCustomerNode = (data, node, ccids) => {
    if (data.object_specific[node]) {
      if (Array.isArray(data.object_specific[node])) {
        data.object_specific[node].map((producer) => {
          if (producer.core_customer_id) {
            ccids.push(producer.core_customer_id);
          }
        });
      } else {
        if (data.object_specific[node].core_customer_id) {
          ccids.push(data.object_specific[node].core_customer_id);
        }
      }
    }
    return ccids;
  };

  const populateScimsCustomerData = (data) => {
    let ccids = [];
    if (data) {
      ccids = addCustomerNode(data, 'producer', ccids);
      ccids = addCustomerNode(data, 'entity', ccids);
      ccids = addCustomerNode(data, 'member_info', ccids);
      ccids = addCustomerNode(data, 'participant', ccids);
      ccids = addCustomerNode(data, 'guardian', ccids);

      if (ccids.length > 0) {
        getCustomers(ccids).then((response) => {
          setScimsCustomers(response.data);
        });
      }
    }
  };

  const handleOnPreviewClicked = ({ esId, pageCount }) => {
    setIsLoadingPreview(true);
    setPreviewPopup(true);
    // setIsLoading(true);
    setDetailsPageCount(pageCount);

    getDocDetail(esId).then((response) => {
      if (response?.isAxiosError === true || response?.response?.status === 404) {
        if (response.response.status === 404) {
          setSearchErrorMessage('No records were found matching your search criteria.');
          setObjectMetadata();
          setSections();
          setMetadataDisplayList(null);
          setIsLoadingPreview(false);
        } else {
          setSearchErrorMessage("We're sorry, something went wrong, please try your search again.");
          setObjectMetadata();
          setDocumentTitle();
          setSections();
          setMetadataDisplayList(null);
          setIsLoadingPreview(false);
        }
        setIsLoadingPreview(false);
        return;
      } else {
        if (response?.data && Object.keys(response.data).length > 0) {
          setObjectMetadata(response.data.metadata);
          setDoc(response.data.documentData.file);
          getFileType(response.data.documentData.fileName);
          setDocumentTitle(response.data.metadata.object_type.object_type_name);
          setSections(response.data.metadata.object_specific.Section);

          objectSpecificList(response.data.metadata.object_type.object_type_name).then((schemaResponse) => {
            // const schema = schemaResponse.data[0].objecttypeMetadata.find((res) => res.metadataStartdate === response.data.metadata.object_type.edition_date);
            const schema = schemaResponse.data[0].objecttypeMetadata[0];
            const required = JSON.parse(schema.metadataRequired);
            Object.keys(required).map((key) => (required[key].searchable === 'false' ? delete required[key] : {}));
            const optional = JSON.parse(schema.metadataOptional);
            Object.keys(optional).map((key) => (optional[key].searchable === 'false' ? delete optional[key] : {}));

            const combined = Object.assign({}, required, optional);
            // const flat = Object.flatten(response.data.metadata.object_specific);

            Object.keys(response.data.metadata.object_specific).map((key) =>
              Object.keys(combined).map((keyMaster) => (keyMaster === key ? (combined[keyMaster].value = response.data.metadata.object_specific[key]) : null))
            );

            populateScimsCustomerData(response.data.metadata);
            setMetadataDisplayList(combined);
            setIsLoadingPreview(false);
            setIsLoading(false);
          });
        } else {
          setSearchErrorMessage("We're sorry, something went wrong, please try your search again.");
          setObjectMetadata();
          setDocumentTitle();
          setSections();
          setMetadataDisplayList(null);
          setIsLoadingPreview(false);
        }
      }
    });
  };

  const customStoredInDRMSList = (props) => {
    return (
      <>
        {successfullyProcessedListLoader && <GlobalLoader />}
        <SuccessfullyProcessedList {...props} onPreviewClicked={handleOnPreviewClicked} />
      </>
    );
  };

  const claimSuspenseQueueJob = async (jobId) => {
    let jobLock = true;
    claimJob(jobId).then((response) => {
      if (response.data) {
        jobLock = response.data['JobLock'];
      }
    });
  };

  const handleResubmit = async (jobId) => {
    setIsLoading(true);
    completeActivity(jobId).then((response) => {
      if (response.data) {
        setIsLoading(false);
      } else {
        console.log('an error occurred attempting to resubmit the object.');
        setIsLoading(false);
      }
    });
  };
  //END Handle Modal Popups

  //Unprocessed Queue Methods
  function refreshUnprocessed() {
    setLoader(true);
    let allFiles = [];
    getWorkQueueDemo({ resultSet: unprocessedResultSet })
      .then((response) => {
        response?.data !== 'No records for the provided filters.' &&
          response?.data['results'].map((job) => {
            allFiles.push({
              isChecked: false,
              ActivityUrl: job.ActivityUrl,
              BatchId: job.BatchId,
              Description: job.Description,
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              EsId: job.EsId,
              FileId: job.FileId,
              FileName: job.FileName,
              FileNameOriginal: job.FileNameOriginal,
              IndexData: job.IndexData,
              IndexSheet: job.IndexSheet,
              JobCompletionDate: job.JobCompletionDate,
              JobId: job.JobId,
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobSubmissionDate: job.JobSubmissionDate,
              ObjectData: job.ObjectData,
              ObjectSheetData: job.ObjectSheetData,
              OfficeId: job.OfficeId,
              PageCount: job.PageCount,
              Thumbnail: job.Thumbnail,
              ThumbnailFileName: job.ThumbnailFileName,
              UploadDate: job.UploadDate,
              UserName: job.UserName,
            });
          });
        if (response.data !== 'No records for the provided filters.') {
          setUnprocessedFilesTotal(response.data['total_hits']);
          setLoader(false);
        } else {
          setUnprocessedFilesTotal(0);
          setLoader(false);
        }
      })
      .then(() => {
        setUploadedFiles(allFiles);
        setLoader(false);
      });
    //setUploadedFiles(allFiles);
  }

  const removeFiles = () => {
    setDeleteFilesInProgress(true);
    const filesRemaining = uploadedFiles.filter((object) => object.isChecked !== true);
    const filesToDelete = uploadedFiles.filter((object) => object.isChecked === true);
    filesToDelete.forEach((file) => {
      deleteKofaxJob(file.FileId).then((response) => {
        setTimeout(() => {
          refreshUnprocessed();
          setDeleteFilesInProgress(false);
          if (response.status && response.status === 204) {
            setUploadedFiles(filesRemaining);
            setMessage('One or more files removed successfully.');
            setIsSuccessGrowlHidden2(false);
            setCheckedAll(false);
            setTimeout(() => {
              setIsSuccessGrowlHidden2(true);
              setMessage('');
            }, 5000);
          } else {
            setMessage('Error: one or more files could not be removed.');

            setIsErrorGrowlHidden2(false);
            setTimeout(() => {
              setIsErrorGrowlHidden2(true);
              setMessage('');
            }, 5000);
          }
        }, 2000);
      });
    });
  };

  const handleAllChecked = (event) => {
    const objects = [...uploadedFiles];
    objects.forEach((object) => (object.isChecked = event.target.checked));
    setUploadedFiles(objects);
    setCheckedAll(!checkedAll);
  };

  const handleCheckChildElement = (event, FileId, BatchId) => {
    let objects = [...uploadedFiles];
    objects.filter((object) => {
      if (object.BatchId === BatchId) {
        if (event.target.checked === false) {
          if (object.FileId === FileId) {
            object.isChecked = event.target.checked;
            return object;
          }
        } else {
          object.isChecked = event.target.checked;
          return object;
        }
      }
    });
    setUploadedFiles(objects);
    const allChildCheckboxesChecked = objects.every((object) => object.isChecked);
    setCheckedAll(allChildCheckboxesChecked);
  };

  const openIndexSheetPopup = () => {
    setIndexSheetPopup(true);
  };

  const handleIndexSheetClose = () => {
    setIndexSheetPopup(false);
  };
  const submitForProcessing = async (indexSheet) => {
    setSubmitToKofaxInProgress(true);
    setLoader(true);

    const indexSheetNew = indexSheet;
    const fileIdMap = new Map(uploadedFiles.filter((file) => file.isChecked).map((file) => [file.FileId, file]));

    if (fileIdMap.size > 0) {
      try {
        for (const id of fileIdMap.keys()) {
          const file = fileIdMap.get(id);
          if (!file) continue;

          const payload = {
            ...indexSheetNew,
            system_folders: {
              ...indexSheetNew.system_folders,
              ObjectType: file.DocTypeName,
            },
            document_ocr_id: file.IndexData?.document_ocr_id,
            object_ocr: file.IndexData?.object_ocr,
          };

          try {
            await submitDirectlyToSubmissionAPI(id, payload);
          } catch (error) {
            console.error(`Submission failed for file ${id}`, error);
          }
        }

        await retrieveWorkQueue();

        setLoader(false);
        setSubmitToKofaxInProgress(false);
        setCheckedAll(false);
        setIndexSheetPopup(false);
      } catch (error) {
        console.error('Unexpected error occurred during submission process', error);
        setLoader(false);
        setSubmitToKofaxInProgress(false);
        setCheckedAll(false);
      }
    } else {
      // Handle the case when no files are selected
      setLoader(false);
      setSubmitToKofaxInProgress(false);
    }
  };

  // END Unprocessed Queue Methods

  //Get Filter Values From SoD
  const getSuspenseQueueFilters = async () => {
    let jobStatusFilter = [];
    let docTypeFilter = [];
    let userFilter = [];

    getWorkQueueFilters().then((response) => {
      response.data &&
        response.data['jobStatusFilter'].map((x) => {
          jobStatusFilter.push({
            JobStatusName: x.jobstatusname,
            JobStatusId: x.jobstatusid,
          });
        });
      response.data &&
        response.data['docTypeFilter'].map((x) => {
          docTypeFilter.push({
            DocType: x.doctype,
          });
        });
      response.data &&
        response.data['userNameFilter'].map((x) => {
          userFilter.push({
            UserName: x.username,
            eauthId: x.eauth_id,
          });
        });
      setJobStatusValues(jobStatusFilter);
      setUserFilterValues(userFilter);
      setDocTypeValues(docTypeFilter);
    });
  };
  //END Get Filter Values From soD
  // multi call populateWorkerQueuedemo
  const retrieveWorkQueue = async () => {
    let allFiles = [];
    let suspenseQueue = [];
    let successfulFiles = [];
    setLoader(true);
    setUploadedLoader(true);
    getWorkQueueDemo({ resultSet: unprocessedResultSet })
      .then((response) => {
        response?.data !== 'No records for the provided filters.' &&
          response?.data['results'].map((job) => {
            allFiles.push({
              isChecked: false,
              ActivityUrl: job.ActivityUrl,
              BatchId: job.BatchId,
              Description: job.Description,
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              EsId: job.EsId,
              FileId: job.FileId,
              FileName: job.FileName,
              FileNameOriginal: job.FileNameOriginal,
              IndexData: job.IndexData,
              IndexSheet: job.IndexSheet,
              JobCompletionDate: job.JobCompletionDate,
              JobId: job.JobId,
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobSubmissionDate: job.JobSubmissionDate,
              ObjectData: job.ObjectData,
              ObjectSheetData: job.ObjectSheetData,
              OfficeId: job.OfficeId,
              PageCount: job.PageCount,
              Thumbnail: job.Thumbnail,
              ThumbnailFileName: job.ThumbnailFileName,
              UploadDate: job.UploadDate,
              UserName: job.UserName,
            });
          });
        if (response.data !== 'No records for the provided filters.') {
          setUnprocessedFilesTotal(response.data['total_hits']);
        } else {
          setUnprocessedFilesTotal(0);
        }
      })
      .then(() => {
        setUploadedFiles(allFiles);
        setUploadedLoader(false);
      });

    getWorkQueueDemo({ resultSet: suspenseQueueResultSet, limit: take })
      .then((response) => {
        response.data !== 'No records for the provided filters.' &&
          response.data['results'].map((job) => {
            suspenseQueue.push({
              FileId: job.FileId,
              isChecked: false,
              FileName: job.FileName,
              UploadDate: Moment(job.UploadDate).format('MM-DD-YYYY'),
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobId: job.JobId,
              JobSubmissionDate: job.JobSubmissionDate,
              ActivityUrl: job.ActivityUrl,
              UserName: job.UserName,
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              LastModifiedBy: job.LastModifiedBy,
            });
          });
        if (response.data !== 'No records for the provided filters.') {
          setSuspenseQueueTotal(response.data['total_hits']);
        } else {
          setSuspenseQueueTotal(0);
        }
      })
      .then(() => {
        setFilesInSuspenseQueue(suspenseQueue);
      });

    getWorkQueueDemo({ resultSet: storedInDRMSResultSet, limit: drmsTake })
      .then((response) => {
        response?.data !== 'No records for the provided filters.' &&
          response?.data['results'].map((job) => {
            successfulFiles.push({
              DocTypeName: job.DocTypeName,
              Edition: job.Edition,
              FileId: job.FileId,
              isChecked: false,
              FileName: job.FileName,
              UploadDate: Moment(job.UploadDate).format('MM-DD-YYYY'),
              JobStatus: job.JobStatus,
              JobStatusNote: job.JobStatusNote,
              JobSubmissionDate: job.JobSubmissionDate,
              JobCompletionDate: job.JobCompletionDate,
              EsId: job.EsId,
              Description: job.Description,
              UserName: job.UserName,
              PageCount: job.PageCount,
              FileNameOriginal: job.FileNameOriginal,
            });
          });
        if (response.data !== 'No records for the provided filters.') {
          setStoredInDRMSTotal(response.data['total_hits']);
        } else {
          setStoredInDRMSTotal(0);
        }
      })
      .then(() => {
        setSuccessfulFilesStoredInDrms(successfulFiles);
        setIsLoading(false);
        setLoader(false);
      });
  };

  const onChangeDocType = async (e, dataItem) => {
    let payload = {};
    payload.fileId = dataItem.FileId;
    payload.objectType = e.label;
    let element = _.findIndex(uploadedFiles, { FileId: dataItem.FileId });
    setLoader(true);
    uploadedFiles[element]['DocTypeName'] = e.label;
    await updateDocTypeName(payload)
      .then((response) => {
        if (response.data) {
          setLoader(false);
          retrieveWorkQueue();
          setMessage('Object Type updated successfully.');
          setIsSuccessGrowlHidden2(false);
          setTimeout(() => {
            setIsSuccessGrowlHidden2(true);
            setMessage('');
          }, 5000);
        } else if (response.error) {
          setLoader(false);
          setMessage('Error: Object Type is not updated successfully.');
          setIsErrorGrowlHidden2(false);
          setTimeout(() => {
            setIsErrorGrowlHidden2(true);
            setMessage('');
          }, 5000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const popover = (props, imgData) => (
    <Tooltip id="button-tooltip" {...props}>
      <div style={{ height: 300, width: '100%' }}>
        <img className="thumbnail" src={imgData} alt="Thumbnail" />
      </div>
    </Tooltip>
  );

  const closeMenuOnScroll = (e) => {
    if (e.target === document || e.target.id === 'virtualListGrid') {
      return true;
    } else {
      return false;
    }
  };
  function UnprocessedList(index, key, style, parent, documentTypes, onChangeDocType) {
    const dataItem = _.cloneDeep(sortedUploadedFiles[index]);

    let imgData = 'data:image/gif;base64,' + dataItem.Thumbnail;
    const docFilterData = (inputValue) => {
      return documentTypes.filter((i) => i.objectTypeName?.toLowerCase().includes(inputValue?.toLowerCase()));
    };
    return (
      <CellMeasurer key={key} cache={cacheMeasure} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <div className="row p-1 border-bottom align-middle m-0" ref={registerChild} style={{ ...style, width: '100%', maxHeight: filtersMinimized ? '27em' : '27em', minHeight: '7em', marginTop: '1.5em' }}>
            <div className="col-1 align-middle pt-3">
              <input
                className="fsa-checkbox "
                disabled={submitToKofaxInProgress}
                key={dataItem.FileId}
                id={dataItem.FileId}
                onChange={(e) => handleCheckChildElement(e, dataItem.FileId, dataItem.BatchId)}
                type="checkbox"
                aria-label="checkbox"
                checked={dataItem.isChecked}
              ></input>
              <label htmlFor={dataItem.FileId}></label>
            </div>
            <div className="col-2">
              {dataItem.Thumbnail ? (
                <>
                  <img className="thumbnail" src={imgData} alt="Thumbnail" />
                  <div className={'pagePreviewImageSection'} onClick={() => handlePreviewImage(dataItem)}>
                    <img style={{ width: '1.5rem' }} src={previewPageIcon} alt="page-preview" />
                  </div>
                </>
              ) : (
                <p className="unprocessed-file-name">No Thumbnail</p>
              )}
            </div>
            <div className="col-4">
              <p className="unprocessed-file-name">
                {/* {dataItem.DocTypeName} */}

                {documentTypes !== undefined && documentTypes.length > 0 && (
                  <AsyncSelect
                    defaultOptions
                    value={Object.keys(dataItem).length !== 0 && dataItem.DocTypeName && { label: dataItem.DocTypeName, value: dataItem.DocTypeName }}
                    loadOptions={(inputValue, callback) => {
                      if (inputValue === '') {
                        let options = [];
                        documentTypes.map((res) => {
                          options.push({ label: res.objectTypeName, value: res.objectTypeUuid });
                          setTimeout(() => {
                            callback(options);
                          }, 1000);
                        });
                        callback(options);
                      } else {
                        let options = [];
                        docFilterData(inputValue).map((res) => {
                          options.push({ label: res.objectTypeName, value: res.objectTypeName });
                          setTimeout(() => {
                            callback(options);
                          }, 1000);
                        });
                        callback(options);
                      }
                    }}
                    onChange={(e) => {
                      onChangeDocType(e, dataItem, uploadedFiles);
                    }}
                    style={customStyles}
                    menuPlacement={'auto'}
                    menuPortalTarget={document.body}
                    closeMenuOnScroll={document.body && closeMenuOnScroll}
                  />
                )}
              </p>
            </div>
            <div className="col-2">
              <p className="unprocessed-file-name">
                {' '}
                {moment(dataItem.UploadDate).format('MM/DD/YY')}
                <br />
                {moment(dataItem.UploadDate).format('HH:mm:ss')}{' '}
              </p>
            </div>
            <div className="col-3">
              <p className="unprocessed-file-name text-trim" title={dataItem.FileNameOriginal}>
                {' '}
                {dataItem.FileNameOriginal}{' '}
              </p>
            </div>
          </div>
        )}
      </CellMeasurer>
    );
  }
  const handlePreviewImage = (thumbObj) => {
    setPreviewImageData({
      image: thumbObj.Thumbnail,
    });
  };
  const cacheMeasure = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 1000,
  });
  const sortedUploadedFiles = [...uploadedFiles].sort((a, b) => {
    const dateA = new Date(a.UploadDate);
    const dateB = new Date(b.UploadDate);
    return dateA - dateB; // Ascending order (oldest first)
  });
  return (
    (isLoading && <LoadingSplash></LoadingSplash>) || (
      <main className="content" tabIndex="-1">
        {loader && <GlobalLoader />}
        <div>
          <div
            className="SuspenseQueueContainer"
            style={
              popupOpen || infoPopUp || OCRPopup || previewPopup
                ? {
                  maxHeight: '70vh',
                  overflowY: 'hidden',
                }
                : {}
            }
          >
            <div className="left-container">
              {/* {userPermissions['Filter_Search_SOD'] === true && (
                <div className={filtersMinimized ? 'half-containers minimized' : 'half-containers filter-section-close'} style={{ overFlow: 'visible' }}>
                  <Collapsible
                    onOpen={() => setFiltersMinimized(false)}
                    onClose={() => setFiltersMinimized(true)}
                    open={false}
                    trigger={
                      <h2 style={{ cursor: 'pointer' }}>
                        Filters
                        {filtersMinimized ? (
                          <FontAwesomeIcon className="float-right chevron" icon={faChevronUp} />
                        ) : (
                          <FontAwesomeIcon className="float-right chevron" icon={faChevronDown} />
                        )}
                        <div className="fsa-divider"></div>
                      </h2>
                    }
                  >
                    <SuspenseQueueFilters jobStatusFilter={jobStatusValues} userFilter={userFilterValues} docTypeFilter={docTypeValues} onApplyFilters={handleApplyFilters} />
                  </Collapsible>
                </div>
              )} */}
              <div className={unprocessedMinimized ? 'half-containers minimized' : 'half-containers unprocessed-section-open'} style={{ marginTop: '5px' }}>
                <Collapsible
                  onClose={() => setUnprocessedMinimized(true)}
                  onOpen={() => setUnprocessedMinimized(false)}
                  open="true"
                  trigger={
                    <h2 style={{ cursor: 'pointer' }}>
                      Uploaded ({unprocessedFilesTotal})
                      {unprocessedMinimized ? (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronUp} />
                      ) : (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronDown} />
                      )}
                      <div className="fsa-divider mb-3"></div>
                    </h2>
                  }
                >
                  <span className="ml-4 pl-2" disabled={uploadedFiles.length === 0}>
                    <input className="fsa-checkbox" disabled={submitToKofaxInProgress} checked={checkedAll} onChange={handleAllChecked} id="selectAll" type="checkbox"></input>
                    <label htmlFor="selectAll">
                      <b>Select All</b>
                    </label>
                  </span>

                  <div style={{ float: 'right', marginTop: '1em', marginBottom: '1em' }}>
                    <div style={{ marginRight: '10px' }} className="fsa-progress-inline">
                      {submitToKofaxInProgress && (
                        <div className="fsa-progress fsa-progress--indeterminate" aria-live="polite">
                          <div className="fsa-progress__details fsa-sr-only">
                            <div className="fsa-progress__label">Loading tracts</div>
                          </div>
                          <div className="fsa-progress__bar" aria-hidden="true">
                            <div className="fsa-progress__primary"></div>
                            <div className="fsa-progress__secondary"></div>
                          </div>
                        </div>
                      )}
                      {userPermissions['Submit_Document_SOD'] === true && (
                        <button
                          disabled={!uploadedFiles.some((object) => object.isChecked === true) || submitToKofaxInProgress}
                          onClick={openIndexSheetPopup}
                          className="fsa-btn  submit-processing-btn"
                        >
                          Submit For Processing
                        </button>
                      )}
                    </div>
                    <div className="fsa-progress-inline">
                      {deleteFilesInProgress && (
                        <div className="fsa-progress fsa-progress--indeterminate" aria-live="polite">
                          <div className="fsa-progress__details fsa-sr-only">
                            <div className="fsa-progress__label">Loading</div>
                          </div>
                          <div className="fsa-progress__bar" aria-hidden="true">
                            <div className="fsa-progress__primary"></div>
                            <div className="fsa-progress__secondary"></div>
                          </div>
                        </div>
                      )}
                      {userPermissions['Remove_Document_SOD'] && (
                        <button
                          disabled={!uploadedFiles.some((object) => object.isChecked === true) || submitToKofaxInProgress || deleteFilesInProgress}
                          onClick={removeFiles}
                          className="fsa-btn fsa-btn--secondary upload-btn"
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>

                  {/* <button 
                  disabled={submitToKofaxInProgress} 
                  onClick={handleUploadButton}
                  className="fsa-btn upload-btn float-right"
                >
                  <span className="k-icon k-i-upload"></span> 
                  Upload
                </button> */}

                  {/* <button className="fsa-btn upload-btn float-right" onClick={() => handleAddButton()}>
                  <img src={AddButton}></img>&nbsp; Add
                </button> */}
                  {/* {console.log(uploadedFiles,"uploadedFiles")} */}
                  <br />
                  {uploadedFiles.length > 0 ? (
                    <div
                      style={{
                        width: '100%',
                        maxHeight: filtersMinimized ? '27em' : '27em',
                        minHeight: '40vh',
                        marginTop: '2.5em',
                      }}
                    >
                      <AutoSizer>
                        {({ width, height }) => {
                          return (
                            <List
                              width={width}
                              height={height}
                              rowCount={sortedUploadedFiles.length}
                              rowHeight={cacheMeasure.rowHeight}
                              deferredMeasurementCache={cacheMeasure}
                              overscanRowCount={3}
                              id="virtualListGrid"
                              rowRenderer={({ index, key, style, parent }) => {
                                return UnprocessedList(index, key, style, parent, documentTypes, onChangeDocType);
                              }}
                              aria-label="Unprocessed Files List"
                            />
                          );
                        }}
                      </AutoSizer>
                    </div>
                  ) : isUploadedLoader ? (
                    <div className="no-list-data">
                      <CircularProgress />
                    </div>
                  ) : (
                    <div className="no-list-data">
                      There are no objects currently in your unprocessed queue.
                      <br></br>
                      Click "Upload" to upload new objects.
                    </div>
                  )}

                  {userPermissions['Add_Document_SOD'] && (
                    <div style={{ float: 'right', marginTop: '1em' }}>
                      <button className="fsa-btn upload-btn float-right" onClick={() => handleAddButton()}>
                        <img src={AddButton} alt="add-btn"></img>&nbsp; Add
                      </button>
                    </div>
                  )}

                  {/* <div style={{float: "right", marginTop: "1em"}}>
                  <div style={{marginRight: "10px"}} className="fsa-progress-inline">
                    {
                      submitToKofaxInProgress && (
                        <div className="fsa-progress fsa-progress--indeterminate" aria-live="polite">
                          <div className="fsa-progress__details fsa-sr-only">
                            <div className="fsa-progress__label">Loading tracts</div>
                          </div>
                          <div className="fsa-progress__bar" aria-hidden="true">
                            <div className="fsa-progress__primary"></div>
                            <div className="fsa-progress__secondary"></div>
                          </div>
                        </div>
                      )
                    }
                    <button
                      disabled={(!uploadedFiles.some(object => object.isChecked === true) || submitToKofaxInProgress)}
                      onClick={openIndexSheetPopup}
                      className="fsa-btn  submit-processing-btn"
                    >
                      Submit For Processing
                    </button>
                  </div>
                  <div className="fsa-progress-inline">
                    {
                      deleteFilesInProgress && (
                        <div className="fsa-progress fsa-progress--indeterminate" aria-live="polite">
                          <div className="fsa-progress__details fsa-sr-only">
                            <div className="fsa-progress__label">Loading</div>
                          </div>
                          <div className="fsa-progress__bar" aria-hidden="true">
                            <div className="fsa-progress__primary"></div>
                            <div className="fsa-progress__secondary"></div>
                          </div>
                        </div>
                      )
                    }
                    <button
                      disabled={!uploadedFiles.some(object => object.isChecked === true) || submitToKofaxInProgress || deleteFilesInProgress}
                      onClick={removeFiles}
                      className="fsa-btn fsa-btn--secondary upload-btn"
                    >
                      Remove
                    </button>
                  </div>
                </div> */}
                </Collapsible>
              </div>
            </div>
            <div className="right-container">
              <button className="fsa-btn fsa-btn--secondary float-right" onClick={handleRefreshQueue}>
                Refresh Queue
              </button>
              {userPermissions['Suspense_Queue_SOD'] === true && (
                <Collapsible
                  style={{ cursor: 'pointer' }}
                  onOpen={() => setSuspenseQueueMinimized(false)}
                  onClose={() => setSuspenseQueueMinimized(true)}
                  open={false}
                  trigger={
                    <h2 style={{ cursor: 'pointer' }}>
                      <FontAwesomeIcon className="suspense-queue-icon" icon={faExclamationTriangle} />
                      Suspense Queue ({suspenseQueueTotal})
                      {suspenseQueueMinimized ? (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronUp} />
                      ) : (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronDown} />
                      )}
                      <div className="fsa-divider"></div>
                    </h2>
                  }
                >
                  {suspenseQueueTotal > 0 ? (
                    <div className="half-containers">
                      <div>
                        <ListView className={`k-listview ${triggerPointFirefox ? 'with-border' : 'with-border2'}`} data={filesInSuspenseQueue} item={customSuspenseQueueList} />
                        <div disabled={suspenseQueueListLoader} onMouseLeave={(event) => TriggerPointFirefoxFunc(event)}>
                          <Pager
                            skip={skip}
                            take={take}
                            total={suspenseQueueTotal}
                            buttonCount={5}
                            info={true}
                            type={'numeric'}
                            pageSizes={[5, 10, 15, 20, 25]}
                            previousNext={true}
                            onPageChange={handleSQPageChange}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="no-list-data">
                      There are no objects currently in your suspense queue for the filters provided.
                      <br></br>
                      Click "Upload" under Unprocessed to upload new objects.
                    </div>
                  )}
                </Collapsible>
              )}

              {userPermissions['Successfully_Stored_In_DRMS_SOD'] === true && (
                <Collapsible
                  style={{ cursor: 'pointer' }}
                  onOpen={() => setSuccessfullyProcessedMinimized(false)}
                  onClose={() => setSuccessfullyProcessedMinimized(true)}
                  open={false}
                  trigger={
                    <h2 style={{ cursor: 'pointer' }}>
                      <FontAwesomeIcon className="suspense-queue-icon" icon={faCheck} />
                      Successfully Stored in DRIMS ({storedInDRMSTotal})
                      {successfullyProcessedMinimized ? (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronUp} />
                      ) : (
                        <FontAwesomeIcon className="float-right chevron" icon={faChevronDown} />
                      )}
                      <div className="fsa-divider"></div>
                    </h2>
                  }
                >
                  {storedInDRMSTotal > 0 ? (
                    <div className="half-containers">
                      <div>
                        <ListView data={successfulFilesStoredInDrms} item={customStoredInDRMSList} />
                        <div disabled={successfullyProcessedListLoader} onMouseLeave={(event) => TriggerPointFirefoxFunc(event)}>
                          <Pager
                            skip={drmsSkip}
                            take={drmsTake}
                            total={storedInDRMSTotal}
                            buttonCount={5}
                            info={true}
                            type={'numeric'}
                            pageSizes={[5, 10, 15, 20, 25]}
                            previousNext={true}
                            onPageChange={handleDRMSPageChange}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="no-list-data">
                      There are no objects currently in your success queue.
                      <br></br>
                      Click "Upload" under Unprocessed to upload new objects.
                    </div>
                  )}
                </Collapsible>
              )}
              <ErrorGrowl
                isErrorGrowlHidden={isErrorGrowlHidden}
                setIsErrorGrowlHidden={setIsErrorGrowlHidden}
                message={invalidFileMsg !== '' ? invalidFileMsg : 'One or more files did not process. Please try again.'}
              />
              <SuccessProcessGrowl
                isSuccessGrowlHidden={isSuccessGrowlHidden}
                setIsSuccessGrowlHidden={setIsSuccessGrowlHidden}
                message={'Successfully submitted for processing.'}
              />
              <ErrorGrowl isErrorGrowlHidden={isErrorGrowlHidden2} setIsErrorGrowlHidden={setIsErrorGrowlHidden2} message={message} />
              <SuccessProcessGrowl isSuccessGrowlHidden={isSuccessGrowlHidden2} setIsSuccessGrowlHidden={setIsSuccessGrowlHidden2} message={message} />
              <DocumentErrorModal isModalOpen={isModalOpen} closeDocErrorModal={closeDocErrorModal} />
            </div>

            <AddToQueueModal
              popupOpen={popupOpen}
              closePopup={closePopup}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              id={id}
              setId={setId}
              retrieveWorkQueue={refreshUnprocessed}
              setIsLoading={setIsLoading}
            />

            <InformationModal
              popupOpen={infoPopUp}
              closePopup={handleInformationPopUpClose}
              jobStatus={infoJobStatus}
              fileName={infoJobFileName}
              jobCreationDate={infoJobCreationDate}
              jobStatusNote={infoJobStatusNote}
              uploadingUser={infoUser}
              refreshQueue={handleRefreshQueue}
              resubmit={handleResubmit}
              jobId={infoJobId}
            />

            <OCRModal popupOpen={OCRPopup} closePopup={handleOCRPopUpClose} activityURL={OCRActivityURL} refreshQueue={handleRefreshQueue} />

            {/* <DetailsView
              popupOpen={previewPopup}
              closePopup={handleOnPreviewClose}
              numPages={numPages}
              doc={doc}
              objectMetadata={objectMetadata}
              onDocumentLoadSuccess={onDocumentLoadSuccess}
              docName={docName}
              docType={docType}
              loading={isLoading}
              metadataDisplayList={metadataDisplayList}
              scimsCustomers={scimsCustomers}
            /> */}
            {previewPopup && (
              <PreviewDocument
                popupOpen={previewPopup}
                closePopup={handleOnPreviewClose}
                numPages={numPages}
                doc={doc}
                objectMetadata={objectMetadata}
                onDocumentLoadSuccess={onDocumentLoadSuccess}
                docName={docName}
                docType={docType}
                loading={isLoadingPreview}
                metadataDisplayList={metadataDisplayList}
                documentTitle={documentTitle}
                sections={sections}
                searchErrorMessage={searchErrorMessage}
              />
            )}

            {/* {indexSheetPopup && ( */}
            <IndexSheetModal
              selectedRows={uploadedFiles.filter((row) => row.isChecked)}
              popupOpen={indexSheetPopup}
              closePopup={handleIndexSheetClose}
              officeId={userInfo.usdaworkofficeID}
              onSubmit={submitForProcessing}
            />
            {/* )} */}

            <SuspenseQueuePopup
              ismodalOpen={ismodalOpen}
              toggleModalCollapse={toggleModalCollapse}
              TriggerPointFirefoxFunc={TriggerPointFirefoxFunc}
              closeUpload={closeUpload}
              isUploadSuccess={isUploadSuccess}
              isModalCollapsed={isModalCollapsed}
              progressVal={progressVal}
              filesData={filesData}
              onFilesAdded={onFilesAdded}
              fileloading={fileloading}
              fileProcessing={fileProcessing}
              onAddInvalidFiles={onAddInvalidFiles}
              filesData1={filesData1}
              errorMsg={errorMsg}
              onCheckVersion={onCheckVersion}
              fileSizeErr={setFileSizeErr}
              setIsErrorGrowlHidden3={setIsErrorGrowlHidden3}
            />
            {previewImageData && (
              <div className={'pageMainContainer'}>
                <div className={'closePageDiv'}>
                  {/* Cross button near Page No */}
                  <img
                    src={ClosePreviewIcon}
                    alt={'close-preview-page'}
                    onClick={() => setPreviewImageData(null)}
                    style={{
                      position: 'absolute',
                      top: '1rem',
                      right: '1rem',
                      border: 'none',
                      width: '2.5rem',
                      height: '2.5rem',
                      cursor: 'pointer',
                    }}
                  />
                </div>
                {/* Thumbnail image */}
                <img
                  src={`data:image/gif;base64,${previewImageData.image}`}
                  alt="Preview"
                  style={{
                    width: '39%',
                    height: '80%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {/* <div class=" css-yk16xz-control"><div class=" css-g1d714-ValueContainer"><div class=" css-1uccc91-singleValue">New Hire Information</div><div class="css-b8ldur-Input"><div class="" style="display: inline-block;"><input autocapitalize="none" autocomplete="off" autocorrect="off" id="react-select-137-input" spellcheck="false" tabindex="0" type="text" aria-autocomplete="list" value="" style="box-sizing: content-box; width: 2px; background: 0px center; border: 0px; font-size: inherit; opacity: 1; outline: 0px; padding: 0px; color: inherit;"><div style="position: absolute; top: 0px; left: 0px; visibility: hidden; height: 0px; overflow: scroll; white-space: pre; font-size: 17px; font-family: &quot;Source Sans Pro&quot;, &quot;Helvetica Neue&quot;, Helvetica, Roboto, Arial, sans-serif; font-weight: 400; font-style: normal; letter-spacing: normal; text-transform: none;"></div></div></div></div><div class=" css-1hb7zxy-IndicatorsContainer"><div class=" css-tlfecz-indicatorContainer" aria-hidden="true"><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg></div><span class=" css-1okebmr-indicatorSeparator"></span><div class=" css-tlfecz-indicatorContainer" aria-hidden="true"><svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg></div></div></div> */}
        <ErrorGrowl isErrorGrowlHidden={isErrorGrowlHidden3} setIsErrorGrowlHidden={setIsErrorGrowlHidden3} message={fileSizeErr} />
      </main>
    )
  );
}